export function formatAge(birthDate: string): string {
  if (!birthDate || birthDate === "Invalid date") return "";
  const d = new Date(birthDate);
  if (isNaN(d.getTime())) return "";
  const today = new Date();
  let age = today.getFullYear() - d.getFullYear();
  if (
    today.getMonth() < d.getMonth() ||
    (today.getMonth() === d.getMonth() && today.getDate() < d.getDate())
  )
    age--;
  return String(age);
}

export function formatRecordDate(iso: string, lang: string): string {
  const d = new Date(iso);
  const hh = String(d.getHours()).padStart(2, "0");
  const mn = String(d.getMinutes()).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const mo = String(d.getMonth() + 1).padStart(2, "0");
  const yy = String(d.getFullYear()).slice(-2);
  const connector = lang.startsWith("pt") ? "às" : "at";
  return `${dd}/${mo}/${yy} ${connector} ${hh}:${mn}h`;
}

export function htmlToPlainText(html: string): string {
  const div = document.createElement("div");
  div.innerHTML = html;
  return (div.textContent || div.innerText || "").replace(/\s+/g, " ").trim();
}
